export default "__VITE_PUBLIC_ASSET__d6995be1__"